"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.23 13c-.64 0-1.13.59-.98 1.21.25 1.12.7 2.18 1.3 3.12.34.54 1.1.61 1.55.16.32-.32.4-.83.15-1.21-.49-.77-.85-1.62-1.05-2.54-.1-.44-.52-.74-.97-.74zm1.86-6.49c-.45-.45-1.21-.38-1.55.16-.6.95-1.04 2-1.3 3.12-.13.62.35 1.21.99 1.21.45 0 .87-.3.97-.74.2-.92.56-1.77 1.05-2.54.24-.38.17-.89-.16-1.21zM11 3.23c0-.64-.59-1.13-1.21-.98-1.12.25-2.18.7-3.12 1.3-.54.34-.61 1.1-.16 1.55.32.32.83.4 1.21.15.77-.49 1.62-.85 2.54-1.05.44-.1.74-.52.74-.97zm6.33.31c-.95-.6-2-1.04-3.12-1.3-.62-.13-1.21.35-1.21.99 0 .45.3.87.74.97.92.2 1.77.56 2.54 1.05.38.24.89.17 1.21-.15.45-.46.38-1.22-.16-1.56zm1.58 13.95c.45.45 1.21.38 1.55-.16.6-.95 1.04-2 1.3-3.12.14-.62-.35-1.21-.98-1.21-.45 0-.87.3-.97.74-.2.92-.56 1.77-1.05 2.54-.25.38-.18.89.15 1.21zM20.77 11c.64 0 1.13-.59.98-1.21-.25-1.12-.7-2.18-1.3-3.12-.34-.54-1.1-.61-1.55-.16-.32.32-.4.83-.15 1.21.49.77.85 1.62 1.05 2.54.1.44.52.74.97.74zM13 20.77c0 .64.59 1.13 1.21.98 1.12-.25 2.18-.7 3.12-1.3.54-.34.61-1.1.16-1.55-.32-.32-.83-.4-1.21-.15-.77.49-1.62.85-2.54 1.05-.44.1-.74.52-.74.97zm-6.33-.31c.95.6 2 1.04 3.12 1.3.62.14 1.21-.35 1.21-.98 0-.45-.3-.87-.74-.97-.92-.2-1.77-.56-2.54-1.05-.38-.24-.89-.17-1.21.15-.45.45-.38 1.21.16 1.55z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "12",
  r: "5"
}, "1")], 'NoiseAwareRounded');

exports.default = _default;